var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchandise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.3121 0.388672H7.7C3.104 0.388672 0.5 2.99267 0.5 7.58867V20.1887C0.5 24.7847 3.104 27.3887 7.7 27.3887H20.3121C24.908 27.3887 27.5 24.7847 27.5 20.1887V7.58867C27.5 2.99267 24.908 0.388672 20.3121 0.388672Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.0317 9.31364H18.7504L16.3731 6.93637C16.1832 6.74647 15.8737 6.74647 15.6768 6.93637C15.4869 7.12627 15.4869 7.43574 15.6768 7.63267L17.3578 9.31364H10.5214L12.2023 7.63267C12.3922 7.44277 12.3922 7.1333 12.2023 6.93637C12.0124 6.74647 11.703 6.74647 11.506 6.93637L9.13582 9.31364H8.85448C8.22148 9.31364 6.90625 9.31364 6.90625 11.1142C6.90625 11.7964 7.04692 12.2465 7.34232 12.542C7.51112 12.7178 7.71508 12.8092 7.93312 12.8585C8.13708 12.9077 8.35512 12.9147 8.56612 12.9147H19.313C19.5311 12.9147 19.735 12.9007 19.932 12.8585C20.5228 12.7178 20.9729 12.2958 20.9729 11.1142C20.9729 9.31364 19.6577 9.31364 19.0317 9.31364Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3244 12.9149H8.5705C8.36653 12.9149 8.14147 12.9078 7.9375 12.8516L8.8237 18.2602C9.02063 19.4699 9.54813 20.8625 11.8902 20.8625H15.8359C18.2061 20.8625 18.6281 19.6739 18.8813 18.3446L19.9434 12.8516C19.7464 12.9008 19.5354 12.9149 19.3244 12.9149ZM13.9439 18.4009C12.2982 18.4009 10.9548 17.0575 10.9548 15.4117C10.9548 15.1233 11.1939 14.8842 11.4823 14.8842C11.7707 14.8842 12.0098 15.1233 12.0098 15.4117C12.0098 16.4808 12.8749 17.3459 13.9439 17.3459C15.013 17.3459 15.8781 16.4808 15.8781 15.4117C15.8781 15.1233 16.1172 14.8842 16.4056 14.8842C16.694 14.8842 16.9331 15.1233 16.9331 15.4117C16.9331 17.0575 15.5897 18.4009 13.9439 18.4009Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchandise);
export default __webpack_public_path__ + "static/media/merchandise.7a3f971447d7aaf8cdc27b425f7b3453.svg";
export { ForwardRef as ReactComponent };